import enTranslations from './en.json'
import esTranslations from './es.json'
import ptTranslations from './pt-BR.json'

export default {
  'pt-BR': ptTranslations,
  'es': esTranslations,
  'en': enTranslations
}